import { useLocation } from "react-router-dom";
import { FeatureFlag, useFeatureFlag } from "../hooks/use-feature-flag";
import config from "../config";
import { useAbTestLogic } from "../hooks/use-abtest-logic/useAbTestLogic";
import { sendEventToSegment } from "../helpers/analytics";

const trackingEvent = () => {
  sendEventToSegment({
    event: 'RentersFlow: page loaded',
    properties: {
      ab_test_variant: 'monolith',
    },
  })
}

export const useRentersRedirectHelper = () => {
  const location = useLocation()
  const [, { featureFlagValue }] = useFeatureFlag(FeatureFlag.REN_5067_UNENROLLED_FLOW)

  useAbTestLogic({
    featureName: FeatureFlag.REN_5245_RENTERS_FLOW_AB_TEST,
    onFeatureOn: () => {
      if (!location?.search.includes('force') && featureFlagValue === 'on') {
        window.location.href = `${config.newRentersFlow}?force=true`
      } else {
        trackingEvent();
      }
    },
    onFeatureOff: () => {
      trackingEvent();
    },
  })
}
